import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';
import { Moment } from 'moment';

export class CustomValidators {

    static minDate(date: Date | Moment): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} | null =>
            control.value < date ? {minDate: {value: true}} : null;
    }

    static maxDate(date: Date | Moment): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} | null =>
            control.value > date ? {maxDate: {value: true}} : null;
    }

    static diffDateToNow(beforeOrAfter: 'before' | 'after', years: number = 0, month: number = 0, days: number = 0): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} | null => {
            if (control.value === null) { return null; }

            const date = moment(control.value).startOf('day');
            const now = moment().startOf('day');

            let diff;
            let comparation;
            if (beforeOrAfter.includes('before')) {
               diff = now.subtract(years, 'years').subtract(month, 'month').subtract(days, 'day');
               comparation = date.isBefore(diff);

            } else {
                diff = now.add(years, 'years').add(month, 'month').add(days, 'day');
                comparation = date.isAfter(diff);
            }

            if (comparation) { return {diffDateToNow: {value: true}}; }

            return null;
        };
    }

    static minimumAge(age: number): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} | null => {
            if (control.value === null) { return null; }

            const date = moment(control.value);
            const now = moment();
            const yearsDiff = now.diff(date, 'years');
           

           if (yearsDiff < age ) {
                return {minimumAge: {value: true}}; 
            }

            return null;
        };
    }
    static checkDNI(): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} | null => {
            const valueToString = new String(control.value)
            if(valueToString.length !==9){
                return null;
            }
            if (!control.value){
                return {checkDNI: {value: true}} 
            } 

            const validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
            const nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
            const nieRexp = /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
            const str = control.value.toString().toUpperCase();
            if (!nifRexp.test(str) && !nieRexp.test(str)) {
                 return {checkDNI: {value: true}}
                }
            
            const nie = str
                .replace(/^[X]/, '0')
                .replace(/^[Y]/, '1')
                .replace(/^[Z]/, '2');

            const letter = str.substr(-1);
            const charIndex = parseInt(nie.substr(0, 8)) % 23;

            if (validChars.charAt(charIndex) === letter) { 
                return null;
             }

            return {checkDNI: {value: true}};
        }
    }

    static checkPostalCode(): ValidatorFn {

        //Comprueba que 1000 < codigopostal_del_control <52999
        return (control: AbstractControl): {[key: string]: any} | null => {
            const valueToString = new String(control.value)
            if (control.value === null){
                return {checkDNI: {value: true}} 
            } 
            const CPRExp = /^(?:0?[1-9]|[1-4]\d|5[0-2])\d{3}$/i;         
            if(control.value){
                const str = control.value.toString();
                if (!CPRExp.test(str))  {
                    return {checkPostalCode: {value: true}}
                }          
            }
            return null;
        }
    }

    static checkAccountNumber(): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} | null => {
            let IBAN = new String(control.value)
             //Se pasa a Mayusculas
            IBAN = IBAN.toUpperCase();
                //Se quita los blancos de principio y final.
            IBAN = IBAN.trim();
            IBAN = IBAN.replace(/\s/g, ""); //Y se quita los espacios en blanco dentro de la cadena
        
            var letra1,letra2,num1,num2;
            var isbanaux;
            //var numeroSustitucion;
            //La longitud debe ser siempre de 24 caracteres
            if (IBAN.length != 24) {
                return {checkAccountNumber: {value: true}};                
            }        
            // Se coge las primeras dos letras y se pasan a números
            letra1 = IBAN.substring(0, 1);
            letra2 = IBAN.substring(1, 2);
            num1 = this.getnumIBAN(letra1);
            num2 = this.getnumIBAN(letra2);
            //Se sustituye las letras por números.
            isbanaux = String(num1) + String(num2) + IBAN.substring(2);
            // Se mueve los 6 primeros caracteres al final de la cadena.
            isbanaux = isbanaux.substring(6) + isbanaux.substring(0,6);
        
            //Se calcula el resto, llamando a la función modulo97, definida más abajo
            let resto = this.modulo97(isbanaux);
            if (resto == '1'){
                return null;
            }else{
                return {checkAccountNumber: {value: true}};
            }                
    
        }
    }


     
    static modulo97(iban):String {
        let parts = Math.ceil(iban.length/7);
        let remainer = "";
    
        for (var i = 1; i <= parts; i++) {
            remainer = String(parseFloat(remainer+iban.substr((i-1)*7, 7))%97);
        }
    
        return remainer;
    }
    
    static getnumIBAN(letra) {
        let ls_letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        return ls_letras.search(letra) + 10;
    }
}
